// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "h4.header[data-v-5cd46636]{margin-top:3px}.note-inputs[data-v-5cd46636]{padding:20px}.center[data-v-5cd46636]{text-align:center}button[data-v-5cd46636]{margin:0 auto}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
